import React from "react";
import {
  TenantMgmtIcon,
  RentTrackingIcon,
  AiCallingIcon,
  NotificationsIcon,
  DashboardIcon,
  PaymentTrackingIcon,
} from "./icons/SvgIcons";

const features = [
  { icon: TenantMgmtIcon, title: "Tenant management", text: "Add, edit, vacate, and track tenant history. Manage occupancy with automatic conflict detection." },
  { icon: RentTrackingIcon, title: "Rent tracking", text: "Full, partial, and multi month payments. Arrears carry forward automatically across months." },
  { icon: AiCallingIcon, title: "AI voice reminders", text: "Let an AI agent call overdue tenants, record transcripts, and capture follow up notes." },
  { icon: NotificationsIcon, title: "SMS reminders", text: "Compose and send bulk or individual SMS reminders with smart templates tailored to tenant status." },
  { icon: DashboardIcon, title: "Live dashboard", text: "See collection rates, overdue counts, outstanding balances, and tenant statuses in real time." },
  { icon: PaymentTrackingIcon, title: "Payment history", text: "Full audit trail of every payment, void, deposit, and note. Per tenant and per house unit." },
];

export default function FeaturesSection() {
  return (
    <section className="border-b border-gray-100 bg-white py-16 dark:border-gray-800 dark:bg-gray-950 sm:py-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-sm font-semibold uppercase tracking-wide text-indigo-600 dark:text-indigo-400">
            Features
          </span>
          <h2 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 dark:text-white sm:text-4xl">
            Everything a landlord needs
          </h2>
          <p className="mt-4 text-lg text-gray-600 dark:text-gray-400">
            Purpose built for Kenyan landlords and property managers.
          </p>
        </div>
        <div className="mt-14 grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {features.map((f) => (
            <div
              key={f.title}
              className="rounded-2xl border border-gray-200 bg-white p-6 transition-shadow duration-200 hover:shadow-md dark:border-gray-700 dark:bg-gray-800"
            >
              <f.icon size={48} bg="#EEF2FF" />
              <h3 className="mt-4 text-base font-semibold text-gray-900 dark:text-white">{f.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-gray-600 dark:text-gray-400">{f.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
